import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export function EditIconButton(props: {
  onClick: () => void;
  tooltipText?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}) {
  const { onClick, tooltipText, disabled, type } = props;
  return (
    <Tooltip title={tooltipText}>
      <IconButton
        disabled={disabled}
        sx={{
          width: {
            xs: "30px",
            sm: "32px",
          },
          height: {
            xs: "30px",
            sm: "32px",
          },
          marginLeft: {
            xs: "auto",
            sm: "0px",
          },
        }}
        onClick={onClick}
        type={type ?? "button"}
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
}
